import { Component, input, model, output, signal, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PetService } from '../../../services/pet/pet.service';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { Pet } from '../../../shared/models/pet.model';
import { PetFormComponent } from '../../forms/pet-form/pet-form.component';
import { finalize } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pet-modal',
  imports: [
    ButtonModule,
    ToggleSwitchModule,
    ModalComponent,
    PetFormComponent,
    FormsModule,
    NgClass
  ],
  templateUrl: './pet-modal.component.html',
  styleUrl: './pet-modal.component.scss'
})
export class PetModalComponent {
  @ViewChild(PetFormComponent) petForm!: PetFormComponent;

  readonly isDelete = input<boolean>(false);
  readonly pet = input<Pet | null>(null);

  readonly isOpen = model.required<boolean>();
  readonly success = output<Pet | null>();

  readonly isLoading = signal<boolean>(false);
  readonly isEnabled = signal<boolean>(true);

  constructor(private readonly petService: PetService,
    private readonly messageService: MessageService) {
  }

  onCloseModal(): void {
    if (this.isLoading()) {
      return;
    }

    this.isOpen.set(false);
  }

  createOrUpdatePet(fields: any): void {
    const isUpdate = this.pet() !== null;

    const { name, birthdate, gender, specie, breed, temperament, foodType, files } = fields;
    const newPet: Pet = { name, birthdate, gender, specie, breed, temperament, foodType, files };

    const formData = new FormData();

    formData.append('name', newPet.name);
    formData.append('birthdate', newPet.birthdate.toISOString());
    formData.append('gender', newPet.gender);
    formData.append('specie', newPet.specie);
    formData.append('breed', newPet.breed ?? '');
    formData.append('foodType', newPet.foodType ?? '');


    temperament.forEach((temp: string) => {
      formData.append('temperament', temp);
    });

    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });

    let serviceAction;
    if (isUpdate) {
      formData.append('id', this.pet()!.id!);
      serviceAction = this.petService.updatePet(formData);
    } else {
      serviceAction = this.petService.createPet(formData);
    }

    serviceAction.subscribe({
      next: (pet: Pet) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Pet ${isUpdate ? 'atualizado' : 'cadastrado'} com sucesso!`,
          life: 4000
        });

        this.success.emit(pet);
        this.isLoading.set(false)
        if (!isUpdate) {
          this.petForm.resetForm();
        }
        this.onCloseModal();
      }, error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: `Falha ao ${isUpdate ? 'atualizar' : 'cadastrar'} pet!`,
          life: 4000
        });
        this.isLoading.set(false);
      }
    });
  }

  deletePet(): void {
    this.isLoading.set(true);
    this.petService.deletePet(this.pet()!.id!)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: () => {
          this.isLoading.set(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Pet deletado com sucesso!',
            life: 4000
          });
          this.success.emit(null);
          this.onCloseModal();

        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao deletar pet!',
            life: 4000
          });
        }
      });
  }
}
